import moment from 'moment';

export const getTimeLeft = (finishTime: string, timerDuration: number): number => {
  const dateFinish = moment(finishTime).utc();
  const dateNow = moment.utc();
  const timeLeft = Math.ceil(dateFinish.diff(dateNow, 'milliseconds') / 1000);

  return timeLeft <= timerDuration && timeLeft >= 1 ? timeLeft : 1;
};
